import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=0f8467dc&scoped=true&"
import script from "./IntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettings.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSettings.vue?vue&type=style&index=0&id=0f8467dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8467dc",
  null
  
)

export default component.exports